import { ButtonIconText, SearchBox } from '@/components';
import { useTranslation } from 'react-i18next';

interface DocumentExplorerToolbarProps {
  searchInput: string;
  onSearchChange: (value: string) => void;
  isAdmin: boolean;
  onNewFolder: () => void;
  onNewFile: () => void;
}

/** Renders the search bar and admin action buttons (new folder / new file). */
export function DocumentExplorerToolbar({
  searchInput,
  onSearchChange,
  isAdmin,
  onNewFolder,
  onNewFile,
}: DocumentExplorerToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-end sm:flex-row gap-3">
      <SearchBox
        className="grow w-full sm:w-auto"
        value={searchInput}
        onChange={onSearchChange}
        placeholder={t('documents.search.placeholder')}
        ariaLabel={t('documents.search.label')}
        clearAriaLabel={t('documents.search.clear')}
      />
      {isAdmin ? (
        <div className="flex flex-wrap gap-2">
          <ButtonIconText iconName="folder" onClick={onNewFolder}>
            {t('documents.actions.newFolder')}
          </ButtonIconText>
          <ButtonIconText iconName="file" onClick={onNewFile}>
            {t('documents.actions.newFile')}
          </ButtonIconText>
        </div>
      ) : null}
    </div>
  );
}
